import dateService from '../services/util/dateService'
import loggingService from '../services/util/loggingService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'projectService'
var path = '/Project/'
var isDebug = false

function get (http, projectId) {
    return http.get(path + 'Get?projectId=' + projectId)
}

function search (http, projectSearchDto) {
    loggingService.log(isDebug, serviceName, 'search')
    return http.post(path + 'Search', projectSearchDto).then(function (response) {
        loggingService.log(isDebug, serviceName, 'search.then')

        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
        })

        return response
    })
}

function putProjectIdentifier (http, projectIdentifier) {
    loggingService.log(isDebug, serviceName, 'putProjectIdentifier')

    return http.put(path + '/ProjectIdentifier', projectIdentifier)
}

function getProjectIdentifier (http, projectIdentifierId) {
    return http.get(path + 'GetProjectIdentifier?projectIdentifierId=' + projectIdentifierId)
}

function searchProjectIdentifier (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'searchProjectIdentifier')
    return http.post(path + 'SearchProjectIdentifier', searchDto).then(function (response) {
        loggingService.log(isDebug, serviceName, 'search.then')
        return response
    })
}

function put (http, project) {
    loggingService.log(isDebug, serviceName, 'put')

    return http.put(path, project)
}

function getIdentifierTypeList () {
    return [
        {projectIdentifierTypeId: 1, description: 'DBA Number'},
        {projectIdentifierTypeId: 2, description: 'REVNO'},
        {projectIdentifierTypeId: 3, description: 'N9RecID'},
        {projectIdentifierTypeId: 4, description: 'ACNO'}
    ]
}

function searchDeletableProjects (http, searchDto) {
    loggingService.log(isDebug, serviceName, 'searchDeletableProjects')
    return http.post(path + 'SearchDeletableProjects', searchDto).then(function (response) {
        loggingService.log(isDebug, serviceName, 'searchDeletableProjects.then')
        _.forEach(response.data, function (value, key) {
            value.createdDate = dateService.convertToDate(value.createdDate)
            value.modifiedDate = dateService.convertToDate(value.modifiedDate)
        })
        return response
    })
}

function remove (http, projectId) {
    loggingService.log(isDebug, serviceName, 'remove')
    return http.delete(path + 'Remove?projectId=' + projectId)
}

function listProjectRandC (http, projectId) {
    return http.get(path + 'ListProjectRandC?projectId=' + projectId)
}

function listInvMigrationRefs (http, projectId) {
    return http.get(path + 'ListInvestigationMigrationRefs?projectId=' + projectId)
}

export default {
    get: get,
    search: search,
    put: put,
    getProjectIdentifier: getProjectIdentifier,
    searchProjectIdentifier: searchProjectIdentifier,
    putProjectIdentifier: putProjectIdentifier,
    getIdentifierTypeList: getIdentifierTypeList,
    searchDeletableProjects: searchDeletableProjects,
    listProjectRandC: listProjectRandC,
    remove: remove,
    listInvMigrationRefs: listInvMigrationRefs
}



// WEBPACK FOOTER //
// ./src/services/projectService.js